import React from "react";
import { Box, Stack } from "@mui/material";
import { ParlorDetailProps } from "../../../types";
import { ColorSystemProps, GOI_WEB_URL } from "../../../constants";
import { ColorIcon } from "../../common/Icons";
function GongsulSection({
  defaultParlor,
  mainColor,
}: {
  defaultParlor: ParlorDetailProps;
  mainColor: ColorSystemProps;
}) {
  return (
    <Box
      style={{
        background: "#fafafa",
        border: "1px solid #edeae9",
        borderRadius: "16px",
        padding: "36px 24px",
      }}
    >
      <Box
        component="h2"
        style={{
          fontSize: "24px",
          fontWeight: 700,
          marginTop: "14px",
          color: "#252525",
        }}
      >
        공설 장례식장, 이렇게 다릅니다.
      </Box>
      <Box
        component="p"
        style={{
          marginTop: "14px",
          fontSize: "16px",
          lineHeight: 1.75,
          color: "#535353",
          maxWidth: "720px",
        }}
      >
        <strong>{defaultParlor.companyname}</strong>은 공공의료원·지자체가
        운영하는 공설 장례식장입니다. 사립 장례식장과 비용 구조·운영 방식이
        달라, 선택 전 특성을 이해하는 것이 좋습니다.
      </Box>
      <Box
        style={{
          marginTop: "28px",
          display: "grid",
          gridTemplateColumns: "1fr",
          gap: "18px",
        }}
        sx={{
          "@media (min-width: 880px)": {
            gridTemplateColumns: "1fr 1fr",
            gap: "24px",
          },
        }}
      >
        <Box
          style={{
            background: "#fff",
            border: "1px solid #e9e9e9",
            borderRadius: "12px",
            padding: "24px 22px",
          }}
        >
          <Box
            style={{
              fontSize: "12px",
              fontWeight: 700,
              letterSpacing: "0.06em",
              color: mainColor.c500,
              marginBottom: "14px",
              display: "flex",
              alignItems: "center",
              gap: "8px",
            }}
          >
            <Box
              component="span"
              style={{
                display: "inline-block",
                width: "8px",
                height: "8px",
                borderRadius: "50%",
                background: "currentColor",
              }}
            />
            공설의 장점
          </Box>
          <Stack
            component="ul"
            gap="8px"
            style={{ padding: 0, listStyle: "none" }}
          >
            {[
              "지방자치단체·공공의료원이 운영하여 비용 체계가 공개적입니다.",
              "지역 장사 정책과 연계되어 장기적으로 안정 운영됩니다.",
              "의료원 부설인 경우 임종·안치 동선이 짧습니다.",
            ].map((text, i) => (
              <Box
                key={i}
                component="li"
                style={{
                  fontSize: "14px",
                  lineHeight: 1.75,
                  color: "#535353",
                  paddingLeft: "16px",
                  position: "relative",
                }}
              >
                <Box
                  component="span"
                  style={{
                    position: "absolute",
                    left: "2px",
                    top: "0.6em",
                    width: "8px",
                    height: "1px",
                    background: "#b9b9b9",
                    display: "inline-block",
                  }}
                />
                {text}
              </Box>
            ))}
          </Stack>
        </Box>

        <Box
          style={{
            background: "#fff",
            border: "1px solid #e9e9e9",
            borderRadius: "12px",
            padding: "24px 22px",
          }}
        >
          <Box
            style={{
              fontSize: "12px",
              fontWeight: 700,
              letterSpacing: "0.06em",
              color: "#252525",
              marginBottom: "14px",
              display: "flex",
              alignItems: "center",
              gap: "8px",
            }}
          >
            <Box
              component="span"
              style={{
                display: "inline-block",
                width: "8px",
                height: "8px",
                borderRadius: "50%",
                background: "currentColor",
              }}
            />
            유의할 점
          </Box>
          <Stack
            component="ul"
            gap="8px"
            style={{ padding: 0, listStyle: "none" }}
          >
            {[
              "전용 주차면이 협소한 경우가 많아 대중교통 안내가 필요합니다.",
              "매점·유족대기실 등 부대시설 선택지가 제한적일 수 있습니다.",
              "빈소 선점 경쟁이 있어 사전 문의·조율이 중요합니다.",
            ].map((text, i) => (
              <Box
                key={i}
                component="li"
                style={{
                  fontSize: "14px",
                  lineHeight: 1.75,
                  color: "#535353",
                  paddingLeft: "16px",
                  position: "relative",
                }}
              >
                <Box
                  component="span"
                  style={{
                    position: "absolute",
                    left: "2px",
                    top: "0.6em",
                    width: "8px",
                    height: "1px",
                    background: "#b9b9b9",
                    display: "inline-block",
                  }}
                />
                {text}
              </Box>
            ))}
          </Stack>
        </Box>
      </Box>
    </Box>
  );
}

export function SupplementarySection({
  defaultParlor,
  mainColor,
  ctaHref,
  ctaText,
}: {
  defaultParlor: ParlorDetailProps;
  mainColor: ColorSystemProps;
  ctaHref?: string;
  ctaText?: string;
}) {
  return (
    <Box padding="0 20px 56px">
      {defaultParlor.managed_type === "공설" && (
        <GongsulSection
          defaultParlor={defaultParlor}
          mainColor={mainColor}
        />
      )}
      {ctaHref && (
        <Box style={{ marginTop: "24px" }}>
          {ctaText && (
            <Box
              style={{
                fontSize: "13px",
                color: "#8f8f8f",
                marginBottom: "10px",
                textAlign: "center",
                whiteSpace: "pre-wrap",
              }}
            >
              {ctaText}
            </Box>
          )}
          <Box
            component="a"
            href={ctaHref}
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "8px",
              padding: "16px",
              borderRadius: "12px",
              fontSize: "16px",
              fontWeight: 700,
              background: mainColor.c400,
              color: "#fff",
              textDecoration: "none",
              textAlign: "center",
            }}
          >
            <span>장례식장 비용 알아보기</span>
            <ColorIcon name="arrow_right_small" color="#fff" size={18} />
          </Box>
        </Box>
      )}
    </Box>
  );
}
